import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';
import { Fragment } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components/macro';
import tw from 'tailwind.macro';
import { questionPropTypes } from '../constants';
import ArticleLink from './ArticleLink';
import FaqDiv from './FaqDiv';
import FaqH1 from './FaqH1';
import FaqH2 from './FaqH2';
import FaqText from './FaqText';
import messages from './messages';
import Redirect from './Redirect';

const CustomFaqH1 = styled(FaqH1)`
  ${tw`mt-0 sm:mt-0`}
`;

const ArticlesList = styled.div`
  ${tw`px-def mt-abs3`}
`;

const CategoryPage = ({ articlesList, category, resetState }) => (
  <FaqDiv>
    <FormattedMessage {...messages.returnToFaq}>
      {(msg) => (
        <Redirect id="redirectHome" methods={() => resetState()} text={msg} />
      )}
    </FormattedMessage>
    <CustomFaqH1>{category.title}</CustomFaqH1>
    <FaqText
      dangerouslySetInnerHTML={{ __html: category.description }}
      id="FaqStyle"
    />
    {isEmpty(articlesList) ? (
      <FaqH2>
        <FormattedMessage {...messages.articlesEmpty} />
      </FaqH2>
    ) : (
      <Fragment>
        <FaqH2>
          <FormattedMessage {...messages.articles} />
        </FaqH2>
        <ArticlesList>
          {articlesList.map((article) => (
            <ArticleLink
              key={article.name}
              articleName={article.name}
              articleTitle={article.title}
            />
          ))}
        </ArticlesList>
      </Fragment>
    )}
  </FaqDiv>
);

CategoryPage.propTypes = {
  articlesList: PropTypes.arrayOf(questionPropTypes),
  category: questionPropTypes,
  resetState: PropTypes.func,
};

export default CategoryPage;
